import { ClientDataGrid } from '@cmg/data-grid';
import React from 'react';

import { useCreateColDefs } from './hooks/useCreateColDefs';
import type { AccountTrait } from './TraitList.model';
import { autoSizeStrategy, getRowId } from './TraitList.model';

export type Props = {
  loading: boolean;
  traits?: AccountTrait[];
};

const NoRowsOverlay: React.FC = () => {
  return <span>No traits found</span>;
};

/**
 * Displays Product Traits in a grid. There is no pagination, the exhaustive list must be passed in.
 */
function TraitList({ traits = [], loading }: Readonly<Props>): React.ReactElement {
  const colDefs = useCreateColDefs();

  return (
    <ClientDataGrid
      rowData={traits}
      columnDefs={colDefs}
      getRowId={getRowId}
      autoSizeStrategy={autoSizeStrategy}
      noRowsOverlayComponent={NoRowsOverlay}
      loading={loading}
    />
  );
}

export default TraitList;
